export default "__VITE_ASSET__919dc226__"